import { TEXT_CONTENT } from '../../../../../utils/constants';
import { DATE_FORMAT, toDisplayDate } from '../../../../../utils/date';
import { minMaxValue } from '../../../../../utils/number';
import { ApexOptions, DowData, GraphDataPoint } from './DowVolumes.types';

const createOptions = (
  defaultOptions: ApexOptions,
  data: GraphDataPoint[],
  apiData: any
) => {
  let { maxY } = minMaxValue(data);

  let response: ApexOptions = {
    ...defaultOptions,
    xaxis: {
      ...defaultOptions.xaxis,
      categories: getCategories(apiData || []),
    },
    yaxis: {
      ...defaultOptions.yaxis,
      max: Math.ceil(maxY) + 5,
    },
  };
  return response;
};

function createGraphData(data: any, defaultOptions: ApexOptions) {
  let DowVolumes_: GraphDataPoint[] =
    data?.map((item: DowData) => ({
      x: toDisplayDate(item.date, DATE_FORMAT.DAY_ONLY),
      y: item.dow_volume,
    })) || [];

  let DowVolumesGraphParams = {
    data: [
      {
        name: TEXT_CONTENT.VOLUME,
        data: DowVolumes_,
      },
    ],
    options: createOptions(defaultOptions, DowVolumes_, data),
  };

  return DowVolumesGraphParams;
}

function getCategories(data: any) {
  return (
    data?.map?.((item: any) => {
      return toDisplayDate(item.date, DATE_FORMAT.DAY_ONLY);
    }) || []
  );
}
export const DOW_GRAPH_OPTIONS: ApexOptions = {
  chart: {
    height: 200,
    stacked: true,
    toolbar: {
      show: true,
      tools: {
        download: false,
        reset: false,
        zoomin: false,
        zoomout: false,
        pan: false,
        selection: false,
        zoom: false,
      },
    },
  },
  colors: ['#7291c2'],
  xaxis: {
    type: 'category',
    title: {
      text: `${TEXT_CONTENT.DAY}`,
    },
  },
  yaxis: {
    min: 0,
    max: 10,
    tickAmount: 3,
    decimalsInFloat: 0,
    title: {
      text: TEXT_CONTENT.VOLUME,
    },
  },
  stroke: {
    show: true,
    curve: 'straight',
    lineCap: 'butt',
    width: 2,
  },
  markers: {
    size: 1.5,
    strokeWidth: 0,
    hover: {
      size: 5,
    },
  },
  dataLabels: {
    enabled: true,
    formatter: function (value) {
      return `${Number(value).toFixed(2)}`;
    },
  },
  tooltip: {
    intersect: true,
    shared: false,
    y: {
      formatter: function (value) {
        return `${value.toFixed(2)}`;
      },
    },
  },
};
export { minMaxValue, createOptions, createGraphData, getCategories };
